/* @jsx h */
import { defineComponent, h } from "vue";
import { OrderPickupDetails } from "@lemmonhq/types";
import { OrderCardFieldValue as FieldValue } from "./FieldValue";
import { useLocalization } from "@lemmonhq/uikit";

interface OrderCardPickupInfoProps {
  pickup: OrderPickupDetails;
}

export const OrderCardPickupInfo = defineComponent<OrderCardPickupInfoProps>({
  name: "OrderCardPickupInfo",
  props: ["pickup"],
  setup(props) {
    const { t } = useLocalization();
    return () => {
      const { pickup } = props;

      return (
        <div>
          <div class="uppercase text-accent font-semibold mb-2">
            {t("orders.pickup.title")}
          </div>
          <div style="grid-template-columns: 70px 1fr;" class="grid text-xs">
            <FieldValue
              label={t("orders.pickup.name")}
              value={`${pickup.name}`}
            />
            <FieldValue
              label={t("orders.pickup.company")}
              value={pickup.company_name}
            />
            <FieldValue label={t("orders.pickup.email")} value={pickup.email} />
            <FieldValue label={t("orders.pickup.phone")} value={pickup.phone} />
            {pickup.day && (
              <FieldValue label={t("orders.pickup.day")} value={pickup.day} />
            )}
            {pickup.time && (
              <FieldValue label={t("orders.pickup.time")} value={pickup.time} />
            )}
          </div>
        </div>
      );
    };
  },
});
